export default __webpack_public_path__ + "static/media/onboarding-background-large.ee7a088c.png";